import React from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'

import Body from './ui/Body'
import Header from './ui/Header'
import Loading from './ui/Loading'
import Tray from './ui/Tray'
import { AppContextProvider } from './utils/AppContext'

import 'normalize.css'
import './scss/common.scss'
import styles from './scss/layout/app.scss'

const App = () => (
    <AppContextProvider render={appContext => (
        <div className={cx(styles.app, { loading: appContext.updatingList })}>
            <Header />
            <Body />
            {!appContext.loadingApp ? <Tray /> : <Loading />}
        </div>
    )} />
)

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js